export enum ApiKeyTypeEnum
{
    Primary = 1,
    Secondary = 2
}


export interface IApiKeyModel
{
    keyType: ApiKeyTypeEnum;
    primaryKey?: string;
    secondaryKey?: string;
    primaryKeyExpiration?: Date;
    secondaryKeyExpiration?: Date;
}

